module.exports = __webpack_public_path__ + "static/media/ldi-hero.365aeea2.jpg";